import { createSlice } from "@reduxjs/toolkit";
import { SellMyCarSteps } from "../../utils/constants/sellMyCar";

const initialState = {
  activeCarSellStep: SellMyCarSteps[0],
  forms: {
    generalInfo: null,
    questionare: null,
    specifications: null,
    gallery: null,
  }
};

const sellMyCarSlice = createSlice({
  name: "sellMyCarDashboard",
  initialState,
  reducers: {
    setActiveCarSellStep: (state, action) => {
      state.activeCarSellStep = action.payload;
    },
    goBackCarSellStep: (state) => {
      state.activeCarSellStep = SellMyCarSteps.indexOf(state.activeCarSellStep) > 0 ? 
        SellMyCarSteps[SellMyCarSteps.indexOf(state.activeCarSellStep) - 1] :
        0;
    },
    setGeneralInfoForm: (state, action) => {
      state.forms.generalInfo = action.payload;
    },
    setQuestionareForm: (state, action) => {
      state.forms.questionare = action.payload;
    },
    setSpecificationsForm: (state, action) => {
      state.forms.specifications = action.payload;
    },
    setGalleryForm: (state, action) => {
      state.forms.gallery = action.payload;
    }
  },
});

export const {
  setActiveCarSellStep,
  setGeneralInfoForm,
  setQuestionareForm, 
  setSpecificationsForm, 
  setGalleryForm,
  goBackCarSellStep
} = sellMyCarSlice.actions;

export default sellMyCarSlice.reducer;
